module.exports = __webpack_public_path__ + "img/IMGP8630b.c58a0138.jpg";